// Modules
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { JwtModule } from '@auth0/angular-jwt';
import { LayoutModule } from './views/layout/layout.module';
import { ToastrModule } from 'ngx-toastr';
import { DropzoneModule, DROPZONE_CONFIG, DropzoneConfigInterface } from 'ngx-dropzone-wrapper';

// Config
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { NoGuard, AdminAuthGuard, AuthGuard, DealerAuthGuard } from '@app/core/guard';
import { AuthInterceptor } from '@app/core/interceptors';

// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';

// Services
import { AlertService } from '@app/services/alert.service';
import { MenuService } from '@app/services/app.menu.service';
import { AuthenticationService } from '@app/services/authentication.service';
import { DomaineService } from '@app/services/domaine.service';
import { UtilisateurService } from '@app/services/utilisateur.service';
import { RoleService } from '@app/services/role.service';
import { PropositionService } from '@app/services/proposition.service';
import { MessageService } from '@app/services/message.service';
import { DataService } from '@app/services/data.service';
import { SharedClickService } from '@app/services/shared-click.service';
import { HttpCancelService } from '@app/services/httpcancel.service';

// App Components
import { AppComponent } from '@app/app.component';
import { ErrorPageComponent } from './views/pages/error-page/error-page.component';

// Auth Injection
export function tokenGetter() {
  // local storage
  if (this.localService?.getJsonValue('currentUtilisateur')) {
    return this.localService?.getJsonValue('currentUtilisateur');
  }
}

const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  clickable: true,
  addRemoveLinks: true,
  resizeWidth: 1600,
  resizeQuality: 0.8,
  maxFiles: 5,//a parametrer
  autoReset: null,
  errorReset: null,
  cancelReset: null,
  autoProcessQueue: false,
  autoQueue: false,
  acceptedFiles: 'image/*',
  dictRemoveFileConfirmation: null
};

@NgModule({
  declarations: [
    AppComponent,
    ErrorPageComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(), // ToastrModule added
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
        allowedDomains: ['localhost:4200', 'netlinkdeal.com'],
        authScheme: "JWT "
      }
    }),
    LayoutModule,
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
    }),
    DropzoneModule
  ],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG
    },
    MenuService,
    AuthenticationService,
    AlertService,
    NoGuard,
    AuthGuard,
    AdminAuthGuard,
    DealerAuthGuard,
    DomaineService,
    UtilisateurService,
    RoleService,
    PropositionService,
    MessageService,
    DataService,
    SharedClickService,
    HttpCancelService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  let i18nPrefix = window.location.pathname.includes('/app/') ? '/app/assets/i18n/' : '/assets/i18n/';
  return new TranslateHttpLoader(http, i18nPrefix, '.json');
}
